import React, { useEffect, useState } from "react";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Collapse } from "react-collapse";
import "./protocolDetails.scss";
import CommonTableOne from "./CommonTableOne";
import CommonTableTwo from "./CommonTableTwo";

const ProtocolDetails = ({
  protocolData,
  onChangeRadio,
  auditNumber,
  error,
  versionData,
}) => {
  // const [getLoading, setGetLoading] = useState(false);
  // const [getError, setGetError] = useState(null);
  // const [AuditedForm, setAuditedForm] = useState();
  // const [AuditVersioning, setAuditVersioning] = useState();
  // const [AuditCompleted, setAuditCompleted] = useState();
  // const [AuditBackForm, setAuditBackForm] = useState();
  const [transformedProtocolData, setTransformedProtocolData] = useState(null);
  const [expanded, setExpanded] = useState({});

  const handleToggle = (section) => {
    setExpanded((prev) => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  function transformAreaOfConcern(data, areaOfConcern) {
    return (
      data &&
      data.map((item, index) => ({
        id: `${areaOfConcern}-${index + 1}`,
        number: item?.number ?? "N/A",
        specification: item?.standardOrTechnicalSpecification ?? "N/A",
        requirementRef: item?.RequirementReference ?? "N/A",
        detailsOfComf: item?.detailsOfNonconformity ?? "N/A",
        evidence: item?.evidenceOfNonconformity ?? "N/A",
        correction: item?.evidenceOfCorrection ?? "N/A",
        rating: item?.nonconformityRating ?? "N/A",
        status: item?.nonConformanceStatus ?? "N/A",
        verificationStatus: "Verified",
        isPreviousYear: item?.isPreviousYear ?? false,
      }))
    );
  }

  function transformFindingsFssc(data, areaOfConcern) {
    return (
      data &&
      data.map((item, index) => ({
        id: `${areaOfConcern}-${index + 1}`,
        number: item?.["Number (#)"] ?? "N/A",
        specification: item?.["Standard or Technical Specifications"] ?? "N/A",
        requirementRef: item?.["Requirement Reference"] ?? "N/A",
        detailsOfComf: item?.["Details of Nonconformity"] ?? "N/A",
        evidence: item?.["Evidence of Non-conformity"] ?? "N/A",
        correction: item?.["Evidence Of Correction"] ?? "N/A",
        rating: item?.["Nonconformity Rating"] ?? "N/A",
        status: item?.["NonConformance Status"] ?? "N/A",
        verificationStatus: "Verified",
        isPreviousYear: item?.["Is Previous Year"] ?? false,
      }))
    );
  }

  function transformFocusArea(obj, focusArea) {
    if (obj && Object.keys(obj).length > 0) {
      return Object.keys(obj).map((key, idx) => ({
        name: key,
        id: `${focusArea}-${key}-${idx}`,
        label: key,
        value: obj[key],
        is_verified: "Verified",
      }));
    }
  }

  const radioButtonHandler = (id, changedData, tabName, status, number) => {
    onChangeRadio(id, changedData, tabName, status, number);
  };
  const transformProtocolFindings = (findings) => {
    if (!findings) return [];

    return findings.map((finding, findingIdx) => {
      const transformedSubsections = finding.subsection
        .map((subsection, subIdx) => {
          return subsection.questions.map((question, qIdx) => ({
            is_verified: question.is_verified,
            label: question.text,
            name: `${finding.section
              .toLowerCase()
              .replace(/\s+/g, "")}${subsection.subSectionName.replace(
                /\s+/g,
                ""
              )}`,
            value: question.answer || "",
            // Use indexes to keep id short and unique
            id: question.question_id,
          }));
        })
        .flat();

      return {
        ...finding,
        subsection: transformedSubsections,
      };
    });
  };

  useEffect(() => {
    if (Object.keys(protocolData).length > 0) {
      let focusAreaData = transformFocusArea(protocolData?.focusArea, "focusArea");
      let areaOfConcernData = transformAreaOfConcern(
        protocolData?.areasOfConcern,
        "areaOfConcern"
      );
      let findingsFsscData = transformFindingsFssc(
        protocolData?.fsscFindings,
        "findingsFssc"
      );

      let transformedFindings = transformProtocolFindings(
        protocolData?.protocolList?.protocolFindings
      );

      setTransformedProtocolData((prev) => {
        return {
          ...prev,
          focusAreaData: focusAreaData,
          areaOfConcernData: areaOfConcernData,
          findingsFsscData: findingsFsscData,
          protocolFindings: transformedFindings,
        };
      });

      // Initialize expanded state for each section
      if (transformedFindings?.length > 0) {
        const initialExpanded = transformedFindings.reduce((acc, finding) => {
          acc[finding.section] = false;
          return acc;
        }, {});
        setExpanded(initialExpanded);
      } else {
        setExpanded({});
      }
    } else {
      setTransformedProtocolData(null);
    }
  }, [protocolData]);

  // console.log("transformedProtocolData", transformedProtocolData);

  return (
    <>
      <div
        id="mars-verification-protocol"
        className="mars-verification-section"
      >
        {transformedProtocolData?.protocolFindings &&
          transformedProtocolData?.protocolFindings.length > 0 &&
          transformedProtocolData?.protocolFindings.map((item, index) => (
            <div className="mars-Audited-Forms-sections mars-verification-common" key={item?.sectionOrderId}>
              <div className="collapse-section">
                <h3 className="main-heading">{item?.section}</h3>
                <div className="collapse-btn" onClick={() => handleToggle(item?.section)}>
                  {expanded[item?.section] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[item?.section]}>
                <CommonTableOne
                  formDetails={item?.subsection ? item?.subsection : []}
                  tabName={item?.section}
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div>
          ))}
        {/*  Scoping  */}

        {/* <div className="mars-Audited-Forms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Scoping</h3>
                <div className="collapse-btn" onClick={() => handleToggle(0)}>
                  {expanded[0] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[0]}>
                <CommonTableOne
                  formDetails={
                    protocolData?.scoping ? protocolData?.scoping : []
                  }
                  tabName="scoping"
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div> */}

        {/*  Quality Not Captured by FSSC  */}

        {/* <div className="mars-AuditedVersioning-Forms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Quality Not Captured by FSSC</h3>
                <div className="collapse-btn" onClick={() => handleToggle(1)}>
                  {expanded[1] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[1]}>
                <CommonTableOne
                  formDetails={
                    protocolData?.qualityNotCapturedFssc
                      ? protocolData?.qualityNotCapturedFssc
                      : []
                  }
                  tabName="qualityFssc"
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div> */}

        {/*  QMS Requirements Not in FSSC  */}

        {/* <div className="mars-AuditedCompleted-Forms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">QMS Requirements Not in FSSC</h3>
                <div className="collapse-btn" onClick={() => handleToggle(2)}>
                  {expanded[2] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[2]}>
                <CommonTableOne
                  formDetails={
                    protocolData?.qmsRequirements
                      ? protocolData?.qmsRequirements
                      : []
                  }
                  tabName="qmsFssc"
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div> */}

        {/*  Specific Requirements  */}

        {/* <div className="mars-Audited-BackForms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">
                  Specific Requirements from Standards- only if applicable to
                  unit in question
                </h3>
                <div className="collapse-btn" onClick={() => handleToggle(3)}>
                  {expanded[3] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[3]}>
                <CommonTableOne
                  formDetails={
                    protocolData?.specificRequirementGovernance
                      ? protocolData?.specificRequirementGovernance
                      : []
                  }
                  error={error}
                  tabName="specificReq"
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div> */}

        {/*   Focus Areas  */}
        {transformedProtocolData &&
          transformedProtocolData["focusAreaData"] &&
          transformedProtocolData["focusAreaData"].length !== 0 && (
            <div className="mars-Audited-BackForms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">
                  Focus Areas - Special Attention
                </h3>
                <div className="collapse-btn" onClick={() => handleToggle(4)}>
                  {expanded[4] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[4]}>
                <CommonTableOne
                  formDetails={
                    transformedProtocolData
                      ? transformedProtocolData?.focusAreaData
                      : []
                  }
                  error={error}
                  tabName="focusArea"
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div>
          )}

        {/*   Areas of Concern  */}

        {transformedProtocolData &&
          transformedProtocolData["areaOfConcernData"] &&
          transformedProtocolData["areaOfConcernData"].length !== 0 && (
            <div className="mars-Audited-BackForms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Areas of Concern- Findings Log</h3>
                <div className="collapse-btn" onClick={() => handleToggle(5)}>
                  {expanded[5] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[5]}>
                <CommonTableTwo
                  formDetails={
                    transformedProtocolData
                      ? transformedProtocolData?.areaOfConcernData
                      : []
                  }
                  error={error}
                  tabName="areasOfConcern"
                  onRadioChange={radioButtonHandler}
                  versionData={versionData || []}
                  textData="Previous Year Non-conformity"
                />
              </Collapse>
            </div>
          )}

        {/*   FSSC Findings  */}
        {transformedProtocolData &&
          transformedProtocolData["findingsFsscData"] &&
          transformedProtocolData["findingsFsscData"].length !== 0 && (
            <div className="mars-Audited-BackForms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">
                  FSSC Findings from Certification Audit
                </h3>
                <div className="collapse-btn" onClick={() => handleToggle(6)}>
                  {expanded[6] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[6]}>
                <CommonTableTwo
                  formDetails={
                    transformedProtocolData
                      ? transformedProtocolData?.findingsFsscData
                      : []
                  }
                  error={error}
                  tabName="findingsFSSC"
                  onRadioChange={radioButtonHandler}
                  versionData={versionData || []}
                  textData="Previous Year FSSC Findings"
                />
              </Collapse>
            </div>
          )}
      </div>

      {/* {protocolData?.protocolType &&
        (protocolData?.protocolType === "Full Scope" ||
          protocolData?.protocolType === "Gap Assessment") && (
          <div
            id="mars-verification-protocol"
            className="mars-verification-section"
          >

            <div className="mars-Audited-Forms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Scoping</h3>
                <div className="collapse-btn" onClick={() => handleToggle(0)}>
                  {expanded[0] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[0]}>
                <CommonTableOne
                  formDetails={
                    protocolData?.scoping ? protocolData?.scoping : []
                  }
                  tabName="scoping"
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div>


            <div className="mars-AuditedVersioning-Forms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Leadership</h3>
                <div className="collapse-btn" onClick={() => handleToggle(1)}>
                  {expanded[1] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[1]}>
                <CommonTableOne
                  formDetails={
                    protocolData?.leadership ? protocolData?.leadership : []
                  }
                  tabName="leaderShip"
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div>

            <div className="mars-AuditedCompleted-Forms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Plan</h3>
                <div className="collapse-btn" onClick={() => handleToggle(2)}>
                  {expanded[2] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[2]}>
                <CommonTableOne
                  formDetails={protocolData?.plan ? protocolData?.plan : []}
                  tabName="planFullScope"
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div>

            <div className="mars-Audited-BackForms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Do</h3>
                <div className="collapse-btn" onClick={() => handleToggle(3)}>
                  {expanded[3] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[3]}>
                <CommonTableOne
                  formDetails={protocolData?.do ? protocolData?.do : []}
                  tabName="doFullScope"
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div>

            <div className="mars-Audited-BackForms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Check</h3>
                <div className="collapse-btn" onClick={() => handleToggle(4)}>
                  {expanded[4] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[4]}>
                <CommonTableOne
                  formDetails={protocolData?.check ? protocolData?.check : []}
                  tabName="checkFullScope"
                  onRadioChange={radioButtonHandler}
                  error={error}
                />
              </Collapse>
            </div>

            <div className="mars-Audited-BackForms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">Act</h3>
                <div className="collapse-btn" onClick={() => handleToggle(5)}>
                  {expanded[5] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[5]}>
                <CommonTableOne
                  formDetails={protocolData?.act ? protocolData?.act : []}
                  tabName="actFullScope"
                  onRadioChange={radioButtonHandler}
                  error={error}
                />
              </Collapse>
            </div>


            <div className="mars-Audited-BackForms-sections mars-verification-common">
              <div className="collapse-section">
                <h3 className="main-heading">
                  Specific Requirements- only if applicable to unit in question
                </h3>
                <div className="collapse-btn" onClick={() => handleToggle(6)}>
                  {expanded[6] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </div>
              </div>

              <Collapse isOpened={expanded[6]}>
                <CommonTableOne
                  formDetails={
                    protocolData?.specificRequirementGovernance
                      ? protocolData?.specificRequirementGovernance
                      : []
                  }
                  tabName="specificRequirements"
                  error={error}
                  onRadioChange={radioButtonHandler}
                />
              </Collapse>
            </div>

            {transformedProtocolData &&
              transformedProtocolData["focusAreaData"] &&
              transformedProtocolData["focusAreaData"].length !== 0 && (
                <div className="mars-Audited-BackForms-sections mars-verification-common">
                  <div className="collapse-section">
                    <h3 className="main-heading">
                      Focus Areas - Special Attention
                    </h3>
                    <div
                      className="collapse-btn"
                      onClick={() => handleToggle(7)}
                    >
                      {expanded[7] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </div>
                  </div>

                  <Collapse isOpened={expanded[7]}>
                    <CommonTableOne
                      formDetails={
                        transformedProtocolData
                          ? transformedProtocolData?.focusAreaData
                          : []
                      }
                      error={error}
                      tabName="focusArea"
                      onRadioChange={radioButtonHandler}
                    />
                  </Collapse>
                </div>
              )}


            {transformedProtocolData &&
              transformedProtocolData["areaOfConcernData"] &&
              transformedProtocolData["areaOfConcernData"].length !== 0 && (
                <div className="mars-Audited-BackForms-sections mars-verification-common">
                  <div className="collapse-section">
                    <h3 className="main-heading">
                      Areas of Concern- Findings Log
                    </h3>
                    <div
                      className="collapse-btn"
                      onClick={() => handleToggle(8)}
                    >
                      {expanded[8] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </div>
                  </div>

                  <Collapse isOpened={expanded[8]}>
                    <CommonTableTwo
                      formDetails={
                        transformedProtocolData
                          ? transformedProtocolData?.areaOfConcernData
                          : []
                      }
                      tabName="areasOfConcern"
                      error={error}
                      onRadioChange={radioButtonHandler}
                      versionData={versionData || []}
                      textData="Previous Year Non-conformity"
                    />
                  </Collapse>
                </div>
              )}

            {transformedProtocolData &&
              transformedProtocolData["findingsFsscData"] &&
              transformedProtocolData["findingsFsscData"].length !== 0 && (
                <div className="mars-Audited-BackForms-sections mars-verification-common">
                  <div className="collapse-section">
                    <h3 className="main-heading">
                      FSSC Findings from Certification Audit
                    </h3>
                    <div
                      className="collapse-btn"
                      onClick={() => handleToggle(9)}
                    >
                      {expanded[9] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </div>
                  </div>

                  <Collapse isOpened={expanded[9]}>
                    <CommonTableTwo
                      formDetails={
                        transformedProtocolData
                          ? transformedProtocolData?.findingsFsscData
                          : []
                      }
                      tabName="findingsFSSC"
                      error={error}
                      onRadioChange={radioButtonHandler}
                      versionData={versionData || []}
                      textData="Previous Year FSSC Findings"
                    />
                  </Collapse>
                </div>
              )}
          </div>
        )} */}
    </>
  );
};

export default ProtocolDetails;
